import { render, staticRenderFns } from "./SupsisText.vue?vue&type=template&id=69153ff3"
import script from "./SupsisText.vue?vue&type=script&lang=js"
export * from "./SupsisText.vue?vue&type=script&lang=js"
import style0 from "./SupsisText.vue?vue&type=style&index=0&id=69153ff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports